// main site version is in proteus, this file still used on outlet

var validateContactUsForm = function () {
	const forms = new forms4i();
	const helpers = new formHelpers4i();
	const contactForm = document.getElementById("contactUsForm");
	const submitBtn = document.getElementById("btnContactUsSubmit");
	const confirmationMsg = document.getElementById("confirmationMessage");
	const successMsg = document.getElementById("contactFrmConfirm");
	const recaptchaErrorMsg = document.getElementById("contactFrmRecaptchaError");
	const recaptchaVerificationLink = document.getElementById("contactFrmRecaptchaLink");
	const specificSite = window.location.href.includes("outlet.4imprint.com") || window.location.href.includes("outlet-sandbox.4imprint.com") || window.location.href.includes("localhost:44338/");
	const messages = {
		Failure: "We were unable to submit your request. Please refresh the page to try again, or contact us by phone at 877-446-7746 or by email at <a href='mailto:4care@4imprint.com'>4care@4imprint.com</a> for further assistance."
	};

	const init = () => {
		if (submitBtn) submitBtn.addEventListener("click", validateForm);
	};

	const validateForm = (e) => {
		e.preventDefault();
		helpers.ShowBusyBtn(submitBtn);
		submitBtn.disabled = true;
		forms.formValidation(contactForm, submitContactUs, e, clearBusyButton);
	};

	const clearBusyButton = () => {
		helpers.ClearBusyBtn();
		submitBtn.disabled = false;
	};

	const submitContactUs = async () => {
		helpers.ClearStatus();

		const recaptchaSiteKey = document.querySelector(".recaptchaSiteKey").value;
		const recaptchaActionName = document.querySelector(".recaptchaActionName").value;

		grecaptcha.execute(recaptchaSiteKey, { action: recaptchaActionName })
			.then(function (token) {
				const data = {
					Email: document.getElementById("Email").value,
					EmailBody: document.getElementById("EmailBody").value,
					RecaptchaActionName: recaptchaActionName,
					RecaptchaToken: token
				};

				submitContactInfo(data);
			})
			.catch(function (error) {
				failure();
				console.error("reCAPTCHA error:", error);
			});
	};

	const submitContactInfo = async (data) => {
		let headers;
		if (specificSite) headers = { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "RequestVerificationToken": contactForm.querySelector("input[name='__RequestVerificationToken']").value };

		let responseJSON;
		try {
			const response = await fetch('/info/submitcontactus', {
				method: 'POST',
				body: JSON.stringify(data),
				headers: headers
			});

			if (!response.ok) {
				failure();
				return;
			}

			responseJSON = await response.json();
		} catch (error) {
			failure();
		}

		if (responseJSON) {
			if (!responseJSON.modelStateInvalid) {
				if (responseJSON.success) showSuccess();
				else if (responseJSON.recaptchaFailed) showRecaptchaError(responseJSON.recaptchaUrl);
				else showError(responseJSON.message);
			} else showError(responseJSON.validationSummary);
		} else failure();
	};

	const hideForm = () => {
		confirmationMsg.classList.remove("hide");
		contactForm.classList.add("hide");
	};

	const showSuccess = () => {
		omniture.ContactSuccess();	
		hideForm();
		successMsg.classList.remove("hide");
		clearBusyButton();
	};

	const showRecaptchaError = (msg) => {
		clearBusyButton();
		hideForm();
		recaptchaErrorMsg.classList.remove("hide");
		recaptchaVerificationLink.setAttribute("href", msg);
		recaptchaVerificationLink.focus();
	};

	const showError = (msg) => {
		if (msg === undefined || msg === null || msg.length === 0) msg = messages.Failure;
		clearBusyButton();
		helpers.ShowErrorStatus(submitBtn, msg);
	};

	const failure = () => {
		helpers.ClearBusyBtn();
		contactForm.classList.add("hide");
		helpers.ShowErrorStatus(submitBtn, messages.Failure);
	};

	const omniture = (function () {
		const contactSuccess = () => {
			const account = typeof s_account === 'string' ? s_account : '4imprintprod';
			const s = typeof s_gi === 'function' ? s_gi(account) : '';
			if (s != '') {
				if (s.pageName) s.pageName = "Contact Form Confirmation";
				if (s.channel) s.channel = "Info Page";
				if (s.prop37) s.prop37 = "infopages/contactformconfirmation";
				s.t();
			}
		};

		return {
			ContactSuccess: contactSuccess
		};
	}());

	return {
		init: init
	};
};

(async () => {
	const contactUsForm = new validateContactUsForm();
	contactUsForm.init();
})();